import {Grommet, Box, Main, Sidebar, Avatar, Heading, Nav, Button, TextInput} from 'grommet';
import { useState } from 'react';
import {Link, Route, Switch} from 'wouter';
import './App.css'
import General from './General';

const theme = {
  "name": "cloudflare",
  "rounding": 4,
  "spacing": 24,
  "defaultMode": "light",
  "global": {
    "colors": {
      "brand": {
        "dark": "#FAAD3F",
        "light": "#F48120"
      },
      "background": {
        "dark": "#111111",
        "light": "#FFFFFF"
      },
      "background-back": {
        "dark": "#111111",
        "light": "#EEEEEE"
      },
      "background-front": {
        "dark": "#222222",
        "light": "#FFFFFF"
      },
      "background-contrast": {
        "dark": "#FFFFFF11",
        "light": "#11111111"
      },
      "text": {
        "dark": "#EEEEEE",
        "light": "#333333"
      },
      "text-strong": {
        "dark": "#FFFFFF",
        "light": "#000000"
      },
      "text-weak": {
        "dark": "#CCCCCC",
        "light": "#444444"
      },
      "text-xweak": {
        "dark": "#999999",
        "light": "#666666"
      },
      "border": {
        "dark": "#444444",
        "light": "#CCCCCC"
      },
      "control": "brand",
      "highlight": "#f5b158",
      "active-background": "background-contrast",
      "active-text": "text-strong",
      "selected-background": "brand",
      "selected-text": "text-strong",
      "status-critical": "#FF4040",
      "status-warning": "#FFAA15",
      "status-ok": "#00C781",
      "status-unknown": "#CCCCCC",
      "status-disabled": "#CCCCCC",
      "graph-0": "brand",
      "graph-1": "status-warning"
    },
    "font": {
      "family": "\"Noto Sans\"",
      "face": "/* cyrillic-ext */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6DRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr4TRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* devanagari */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr5DRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;\n}\n/* greek-ext */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6TRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr5jRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6jRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6zRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr5TRASf6M7Q.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n"
    },
    "active": {
      "background": "active-background",
      "color": "active-text"
    },
    "hover": {
      "background": "active-background",
      "color": "active-text"
    },
    "selected": {
      "background": "selected-background",
      "color": "selected-text"
    }
  },
  "chart": {},
  "diagram": {
    "line": {}
  },
  "meter": {}
}

const WORKER_URL = "https://submissions.apply.cloudflareworkers.com"

function App() {

  const [email, setEmail] = useState("");

  const retryCreate = async () => {
    fetch(WORKER_URL + "/cmd/retry_create",
    {
      method: "post",
      body: JSON.stringify({
        email
      })
    })
  }

  return (
    <Grommet theme={theme} style={{height: "100%"}}>
      <Box direction="row" height="100%">
        <Sidebar background="brand" width="max-content" round={{corner: "right"}} style={{display: window.innerWidth < 1150 ? "none" : "initial"}}
          header={
            <Box direction="row" width="max-content" align="center" round="small">
              <Avatar round="small" src="/Cloudflare-emblem-1024x726.jpeg" margin={{right: "small"}} pad="30px"
                style={{paddingBottom: "3px", "border": "10px solid #fff"}}/>
              <Heading level="2" color="white" margin={{right: "xsmall"}}>Cloudflare Hiring</Heading>
            </Box>
          }
        >
          <Nav direction="column" gap="small">
            <Link href="/">
              <Button size="large" style={{width: "90%", textAlign: "center"}} color="highlight" primary 
                alignSelf="center" pad="small" margin="small" hoverIndicator label="Get Started"/>
            </Link>
            <Link href="/general">
              <Button size="large" style={{width: "90%", textAlign: "center"}} color="highlight" primary 
                alignSelf="center" pad="small" margin="small" hoverIndicator label="General Assignment"/>
            </Link>
            <Link href="/systems">
              <Button size="large" style={{width: "90%", textAlign: "center"}} color="highlight" primary 
                alignSelf="center" pad="small" margin="small" hoverIndicator label="Systems Assignment"/>
            </Link>
          </Nav>
        </Sidebar>
        <Main>
          <Switch>
            <Route path="/about">
              <Box pad={{"left": "medium", "right": "medium"}}>
                <General link="about.md"/>
              </Box>
            </Route>
            <Route path="/">
              <Box pad={{"left": "medium", "right": "medium"}} overflow="auto">
                <General link="start.md"/>
              </Box>
              <Box direction="row" margin="medium" align="center" gap="small">
                <Heading level={4}>{
                  window.innerWidth < 1150 ? "Retry sending email" 
                  : "If you didn't receive an email with your instructions, please enter your email and click Retry."}</Heading>
                <TextInput placeholder="Email" label="email" value={email} onChange={e => setEmail(e.target.value)}/>
                <Button primary label="Retry" style={{height: "50%"}} onClick={retryCreate}/>
              </Box>
            </Route>
            <Route path="/general">
              <Box pad={{"left": "medium", "right": "medium"}}>
                <General link="general.md"/>
              </Box>
            </Route>
            <Route path="/systems">
              <Box pad={{"left": "medium", "right": "medium"}}>
                <General link="systems.md"/>
              </Box>
            </Route>
          </Switch>
        </Main>
      </Box>
    </Grommet>
  );
}

export default App;
